import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"width":"500","overlay-color":"rgba(39, 50, 64)","overlay-opacity":"0.6","fullscreen":_vm.$vuetify.breakpoint.xs ? true : false,"persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c(VCard,[_c(VCardTitle,[_c(VSpacer),_c(VBtn,{attrs:{"icon":""},on:{"click":function($event){return _vm.closeDialog()}}},[_c(VIcon,[_vm._v("mdi-close")])],1)],1),_c(VCardText,[(_vm.dialog)?_c('gateways',{attrs:{"invoice-id":_vm.invoiceId},on:{"closeDialog":_vm.closeDialog}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }